// extracted by mini-css-extract-plugin
module.exports = {"badgeWiOptions":"BadgeWithOptions_badgeWiOptions__x9zua","badgeWiOptions_content":"BadgeWithOptions_badgeWiOptions_content__3s5L7"};